// https://daveceddia.com/react-redux-immutability-guide/
import {
  // ACTIVAR_SPINNER,
  // CAMBIAR_EMAIL,
  // CAMBIAR_STRING_AUTH,
  // CERRAR_ERROR_MODAL,
  // ERROR_MESSAGE_API,
  // LOGIN_SUCCESS_EN_API,
  // RESET_CODIGO_VALIDACION_EMAIL,
  // RESET_PASSWORDS,
  // RESET_TELEFONOS,
  // SET_DATOS_USER,
  // SET_DATOS_USER_BASE,
  SET_TO_INITIAL_VALUES,
  // UPDATE_EMAIL,
  // UPDATE_TELEFONOS,
  // VALIDAR_EMAIL,
  // VALIDAR_STRING,
} from '../actions/types';

const INITIAL_STATE = {
  roles: [],
  //usuario_id: '',
  //tipo_documento: '',
  //empresa: '',
  //nombre: '',
  //apellidos: '',
  //email: '',
  //email_validado: false,
  //preTel: '',
  //preTelCodigo: '',
  //tel: '',
  //tel_validado: false,
  //valoracion_media: 0.123456789,
  //mostrar_mensajes_ayuda: true,
  //// cambiar_email: null,
  //// cambiar_email_valido: false,
  //// validar_email_codigo: null,
  //// validar_email_codigo_valido: false,
  //// password: null,
  //// password_valido: false,
  //// recupera_clave_codigo: null,
  //// recupera_clave_codigo_valido: false,
  //// cambiar_clave: null,
  //// cambiar_clave_valida: false,
  //// cambiar_clave_nueva: null,
  //// cambiar_clave_nueva_valida: false,
  //// cambiar_clave_nueva_repeticion: null,
  //// cambiar_clave_nueva_repeticion_valida: false,
  //// preTel: '+34',
  //// preTelCodigo: 'ES',
  //// tel: null,
  //// tel_validado: false,
  //// tel_valido: false,
  //// new_tel: null,
  //// new_tel_valido: false,
  //// new_preTel: '+34',
  //// new_preTelCodigo: 'ES',
  //// loading: false,
  //// mostar_modal: false,
  //// error_api: null,
  //// mensaje_info: null,
  //// mostrar_mensaje_info: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TO_INITIAL_VALUES:
      return { ...state, ...INITIAL_STATE };
    // case VALIDAR_STRING:
    //   return { ...state, [action.string.prop]: action.string.value, [action.validacion.prop]: action.validacion.value };
    //case CAMBIAR_STRING_AUTH:
    //  return { ...state, [action.string.prop]: action.string.value };
    // case SET_DATOS_USER:
    //   return { ...state, nombre: action.nombre, apellidos: action.apellidos, email: action.email, email_validado: action.email_validado, preTel: action.preTel, preTelCodigo: action.preTelCodigo, tel: action.tel, tel_validado: action.tel_validado, valoracion_media: action.valoracion_media, usuario_id: action.usuario_id, tipo_doc: action.tipo_doc, nif: action.nif };
    // case ERROR_MESSAGE_API:
    //   return { ...state, loading: false, error_api: action.error, mostar_modal: true };
    // case CERRAR_ERROR_MODAL:
    //   return { ...state, error_api: null, mostar_modal: false };
    // case ACTIVAR_SPINNER:
    //   return { ...state, loading: true, error_api: null };
    //case SET_DATOS_USER_BASE:
    //  return { ...state, roles: action.roles, usuario_id: action.usuario_id, tipo_documento: action.tipoDoc, empresa: action.empresa, nombre: action.nombre, apellidos: action.apellidos, email: action.email, email_validado: action.email_validado, preTel: action.preTel, preTelCodigo: action.preTelCodigo, tel: action.tel, tel_validado: action.tel_validado, valoracion_media: action.valoracion_media, mostrar_mensajes_ayuda: action.mostrar_mensajes_ayuda };
    // case RESET_PASSWORDS:
    //   return { ...state, password: null, password_valido: false, cambiar_clave: null, cambiar_clave_valida: false, cambiar_clave_nueva: null, cambiar_clave_nueva_valida: false, cambiar_clave_nueva_repeticion: null, cambiar_clave_nueva_repeticion_valida: false };
    // case CAMBIAR_EMAIL:
    //   return { ...state, cambiar_email: action.cambiar_email, cambiar_email_valido: action.cambiar_email_valido };
    // case UPDATE_EMAIL:
    //   return { ...state, email: action.email, email_validado: false, mensaje_info: action.mensaje_info, cambiar_email: null, cambiar_email_valido: null, mostrar_mensaje_info: true };
    // case VALIDAR_EMAIL:
    //   return { ...state, validar_email_codigo: null, validar_email_codigo_valido: false, email_validado: true, mensaje_info: action.mensaje_info, mostrar_mensaje_info: true };
    // case RESET_CODIGO_VALIDACION_EMAIL:
    //   return { ...state, validar_email_codigo: null, validar_email_codigo_valido: false };
    // case UPDATE_TELEFONOS:
    //   return { ...state, preTel: action.pre_tel, preTelCodigo: action.pre_tel_codigo, tel: action.tel, tel_validado: false, mensaje_info: action.mensaje_info, mostrar_mensaje_info: true };
    // case RESET_TELEFONOS:
    //   return { ...state, new_preTelCodigo: 'ES', new_preTel: '+34', new_tel: null, new_tel_valido: false };
    default:
      return state;
  }
};
